'use strict';
var tooltip = require('../tooltip'),
	util = require('../util'),
	dialog = require('../dialog'),
	validator = require('../validator'),
	imagesLoaded = require('imagesloaded'),
	ajax = require('../ajax'),
	tealium = require('../../../../int_tealium/cartridge/js/tealium/tealium'),
	progress = require('../progress');
function madeOfferAjax(rebuttal,presentation) {
	var url = util.appendParamsToUrl(Urls.madeOffer, {'rebuttal': rebuttal, 'presentation':presentation});
	ajax.load({
        url: url,
        callback: function (data) {
           //var fail = false;
           if ($('.pt_checkout .spc-summary').length > 0) {
                 require('../spc').initPreScreen();
           } else {
                 if($('.express-billing-refresh').length > 0) {
                	 $(".express-billing-refresh[data-refreshurl]").trigger('click'); 
                 } else {
                	 $(".spc-billing .billing-refresh[data-refreshurl]").trigger('click');
                 }
           }
	    }
	 });
}

function scrollToActiveTab(billType) {  
	var scrDiff = billType === 'expBill' ? 50 : 15;
	if(!$(".ui-dialog").is(":visible")) {
		if($('.checkout-tab-head.open').length) {
	    	$('html, body').animate({ scrollTop: $('.checkout-tab-head.open').offset().top - $('.pt_checkout #header').outerHeight() - scrDiff }, 700);
	    }
	}
}
/* PXSFCC-4238 */
function addBottomPaddingDuringStickyButtons () {
	if( $(".plcc-web-and-preapproved-form").length > 0 && $(window).width() < 1025 ) {
		var stickyButtonHeight = $(".plcc-web-and-preapproved-form").find(".bottom-buttons").outerHeight();
		$(".footer-container.footer-down").css("padding-bottom",stickyButtonHeight +"px");
	} else {
		$(".footer-container.footer-down").css("padding-bottom", 0 +"px");
	}
}
function initializeEvents() {
	// To fix SM-2414 below line has been commented
	//util.updateInputFields();
	$('input.ssn').unmask().maskSSN('999-99-9999', {maskedChar:'X', maskedCharsLength:5, numericMaskedCharEquivalent:'9'});
	if($(".billing-cards-section,.spc-summary").find("acquisition-rebuttal1")) {
        var name = $(".acquisition-rebuttal1").data("name");
        var creditLimit = $(".acquisition-rebuttal1").data("creditlimit");
        $(".plcc-pre-approved-name").text(name);
        $(".plcc-pre-approved-creditlimit").text(creditLimit);
	}
	/* PXSFCC-4238 */
	if( $(".plcc-web-and-preapproved-form").length > 0 ) {
		addBottomPaddingDuringStickyButtons();
		
		$(window).resize(function(){
			addBottomPaddingDuringStickyButtons();
		});
	}
	$("body").off("click",".heading-click").on("click",".heading-click",function(){
    	var $parent = $(this).closest(".plcc-form-section");
    	if(!$parent.hasClass("active")) {
    		$parent.addClass("active");
    		var $authorizeInfo = $('.plcc-authorized-buyer-block input,.plcc-authorized-buyer-block select');
    		$authorizeInfo.removeClass("error").closest(".form-row").removeClass("error-handle");
    		$parent.find(".plcc-authorized-buyer-section").slideDown();
    	} else {
    		$parent.removeClass("active");
    		$parent.find(".plcc-authorized-buyer-section").slideUp();
    	}
    });
	
	$("body").on('click',".plcc-edit-profile", function(e) {
        e.preventDefault();
		var modalEl = $('.checkout-plcc-modal-step2 .ui-dialog-content');
		var modalHeight = modalEl.height();

        $(this).closest('.plcc-profile-summary').hide();
        $('.show-profile').show();
        util.updateInputFields();

		$('.plcc-application-fieldset').css({height: modalHeight});
		
		var isIpad = ['iPad'].indexOf(navigator.platform) >= 0;
		isIpad && $('.show-profile').css('paddingBottom', '120px');
    });
	
	$("body").off("keypress",".ui-dialog-titlebar-close").on("keypress",".ui-dialog-titlebar-close",function(e){
		if($(this).closest('.ui-dialog').hasClass('plcc-ssn-info-dialog')){
			if(e.type === "keypress"){
	            if (e.which !== 13) return;
	            setTimeout(function() { 
					$(".plcc-primary").find(".question-mark-icon.plcc-ssn-info").addClass("focus-outline").focus();
				 }, 10);
	        }
		}	
    });
	
	
	$('.submit-terms input').on('click',function(){
	    if ($(this).is(':checked')) {
			$('.submit-terms label .label-text').removeClass('error-terms');
		}
	});
	
	$("body").off('blur','input.alternativePhone').on('blur','input.alternativePhone', function(){
	    if($(this).val().length == 0) {
	    	var $formRow = $(this).closest('.form-row.alternativePhone');
	    	$formRow.removeClass('error-handle');
			$formRow.find('label span.error').hide();
	    }
	});
	$(".plcc_web_application_form, .plcc_preapproved_application_form").off("submit").on("submit",function(e){
		e.preventDefault();
		var $form = $(this).closest('form'),
			action = $form.attr("action");
		var phone =  $form.find('input.phone').val();
		var altPhone =  $form.find('input.alternativePhone').val();
	
		if($('input.alternativePhone').hasClass('phone')){
			$('.alternativePhone').removeClass('phone');
		}
		
		if ((phone == undefined || phone == '' || phone == null) && (altPhone == undefined || altPhone == '' || altPhone == null)) {
			$form.find('.phone').addClass('required');
			$form.find('input.phone').attr('data-required-text',Resources.PHONE_REQ_MESSAGE);
		} else {
			$form.find('.phone').removeClass('required');
			$form.find('input.phone').removeAttr('data-required-text');
		}
		
		var authorizeInfo = $('.plcc-authorized-buyer-block input:visible,.plcc-authorized-buyer-block select:visible');
		var isAuthorizeBuyer = false;
    	if (authorizeInfo.length > 0) {
	  		isAuthorizeBuyer = true; 
        }

		if (isAuthorizeBuyer) {
			authorizeInfo.each(function () {
				var $curObj = $(this);
				var errorText = $curObj.closest(".form-row").find(".label-text").text();
				$curObj.addClass('required');
				$curObj.attr('data-required-text',errorText);
			});
		} else {
			authorizeInfo.each(function () {
				var $curObj = $(this);
				$curObj.removeClass('required');
				$curObj.removeAttr('data-required-text');
		    	$curObj.closest(".form-row").removeClass("error-handle").addClass("show-text");
			});
		}
		if (!$form.valid()) {
			if(!($('.submit-terms input').is(':checked'))) {
				$('.submit-terms label .label-text').addClass('error-terms'); 
			}
			$('.invalid-form').removeClass('hide');
            return false;
        } else {
        	$('.submit-terms label .label-text').removeClass('error-terms');
        	$('.invalid-form').addClass('hide');
        	$(".pre-approved-submit,.web-instant-submit").attr('disabled', 'disabled');
        }
		var buttonName = $form.find("button[type='submit']").attr("name");
		$('<input type="hidden" name="' + buttonName + '" value="true" />').appendTo($form);
		$.ajax({ 
			url: action,
			data: $form.serialize(),
			method: 'POST', 
			success: function(data) {
				if(data != '') {
					$('.invalid-ssn-error').addClass('hide');
					var dialogContent = $(data);
					dialog.open({
			            html: dialogContent,
			            options: {
			                width: 700,
			                closeOnEscape  : false,
				            closeOnOverlayClick: false,
			                dialogClass: "plcc-apply-error-model",
			            },
			            callback: function () {
			            	if($('.approved-model').length > 0 ){
			            		var obj = {
			            			event_name : "plc_registration"
			                	}
			        			tealium.triggerEvent(obj);
			            	}
			            	
			            	$('.continue-shopping').on('click',function(e){
			            		e.preventDefault();
			            		window.location.assign(Urls.home);
			            	});
			            	$('.continue-checkout').on('click',function(){
			            		e.preventDefault();
			            		$(this).closest(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("click");;
			            	});
			            	$('.guest-sign-in').on('click',function(e){
			            		e.preventDefault();
			            		window.location.assign(Urls.logIn);
			            	});
			            	$('.try-again').on('click',function(e){
			            		e.preventDefault();
			            		window.location.reload();
			            	});
			            }
			        });
				} else {
					if( $(".form-row.ssn").find(".server-error").length <= 0 ) {
                        var serverError = '<span class="server-error">' + $(".invalid-ssn-error").text() + '</span>';
                        $(".form-row.ssn").removeClass("show-text").addClass("error-handle").find("label").prepend(serverError);
                        $(".pre-approved-submit,.web-instant-submit").removeAttr('disabled');
					}
				}
			}
			
		});
	});
	
		
}

var madeOfferCall = true;
var rebuttal = false;
var presentation = 'PREAPPROVED_NO';

var preApprovedInit = {
	showRebuttal: true,
	events: function() {
		var rebuttalSlot = $('.rebuttal-slot');
		if (this.showRebuttal && rebuttalSlot.length) {
			this.showRebuttal = false;
			$("body").off("click",".plcc-application-open").on("click",".plcc-application-open", credit.openApplication);
	
			$("body").off("click",".plcc-terms-open").on("click",".plcc-terms-open", function(e) {
				e.preventDefault();
				credit.openTermsAndConditions(false, credit.modalHeight);
			});
	
			$('.plcc-rebuttal-accordion-content').accordion({
				collapsible: true,
				active: false
			});
	
			$("body").off("click",".plcc-details-open.plcc-rebuttal-link").on("click",".plcc-details-open.plcc-rebuttal-link", function(e) {
				e.preventDefault();
				var $accordionController = $('.plcc-rebuttal-accordion-content .plcc-accordion-control');
				$accordionController.trigger('click');
				if ($($accordionController).hasClass('ui-accordion-header-active')) {
					e.currentTarget.innerHTML = 'Close';
				} else {
					e.currentTarget.innerHTML = 'Details';
				}
			});
		} else if (!this.showRebuttal && rebuttalSlot.length) {
			rebuttalSlot.addClass('hide');
		}
	}
}
var credit = {
    init: function () {
        initializeEvents();
        preApprovedInit.events();
        credit.stepOneEvents();
    },
	modalHeight: 'auto',
	modalWidth: 340,
	createDialog: function(className, event_location_plc){
		return dialog.create({
			options:{ 
				width: credit.modalWidth, 
				closeOnEscape: false,
				closeOnOverlayClick: false,
				draggable: false,
				dialogClass: className,
				height:credit.modalHeight,
				maxHeight:credit.modalHeight,	
				position:{
					my: "center",
					at: "center",
					of: window
				},
				title: className !== 'checkout-plcc-modal-terms' && SitePreferences.PLCC_BRAND_STORENAMES[siteInfo.brandContextID] + ' Credit Card Offer',
				open: function () {
					$('html').addClass('no-scroll')
					$('.checkout-body').addClass('no-scroll-checkout');
					// ensure that dialog content is pinned to top of container
					if (dialog.$container && dialog.$container.scrollTop() > 0) {
						dialog.$container.scrollTop(0);
					}
				},
				close: function () {
					$('html').removeClass('no-scroll')
					$('.checkout-body').removeClass('no-scroll-checkout');
					if(className !== 'checkout-plcc-modal-step3' && className !== 'checkout-plcc-modal-terms'){
						madeOfferAjax(!preApprovedInit.showRebuttal, presentation)
						var obj = {
							event_name: "plc_offer_refused",
							event_location_plc: event_location_plc
						};
						tealium.triggerEvent(obj)
						scrollToActiveTab()
					}
				}
			} 
		})
	},
	xsWindowHeight: function(dlgName, className, prevHeight){ 
		var $windowheight = $(window).height();
		var xsModalHeight = $windowheight - 10;
		var xsContentHeight = xsModalHeight - 57;
			$(className).css({height: xsModalHeight + 'px', overflowY:'auto'});
			dlgName.css({ minHeight: xsContentHeight + 'px', maxHeight: xsContentHeight + 'px', height: prevHeight });
	},
	setDlgPosition: function(dlgName){
		$(dlgName).dialog("option", "position", {
			my: "center",
			at: "center",
			of: window
		});
	},
	setHeights: function(className){
		$(className).css({height:credit.modalHeight});
		$(className + ' .ui-dialog-titlebar').css({height:credit.titleHeight});
		$(className + ' .dialog-content').css({minHeight:credit.modalContentHeight, maxHeight:credit.modalContentHeight, height:credit.modalContentHeight });
	},
	controlHeightStep3: function(className, childClass){
		var $windowheight = $(window).height();
		var isSmallWindow = $windowheight < $(className).height();
		var xsModalHeight = $windowheight - 10;
		var xsContentHeight = xsModalHeight - 57;
		if(isSmallWindow){
			$(className).css({height: xsModalHeight + 'px'});
			$(className + ' .dialog-content').css({ maxHeight: (xsContentHeight) + 'px',overflowY:'auto' }); 
			$(childClass).css({ height:xsContentHeight, minHeight:xsContentHeight, maxHeight:xsContentHeight });
		}else{
			$(className + ' .dialog-content').css({minHeight:credit.modalContentHeight, overflowY:'auto'});
			$(childClass).css({ height: credit.modalContentHeight, minHeight:credit.modalContentHeight, maxHeight:credit.modalContentHeight });
		}
	},
	stepOneEvents: function(e, prevHeight) {
		if ($(".checkout-stepone-modal").length > 0 ) {
	    	var $modalContent = $(".checkout-stepone-modal")
			var tootltipDlg =  credit.createDialog('checkout-plcc-modal', "plc_initial_overlay")
			
			$(tootltipDlg).children().remove();
			$(tootltipDlg).append($modalContent.html());
			credit.stepOneContinueEvents();
			$(tootltipDlg).find('.plcc-preapproved-name').html(", " + $('.offer-content').data('name'));
			$(tootltipDlg).find('.plcc-preapproved-credit').html($('.offer-content').data('creditlimit'));
			tootltipDlg.dialog("open");
			credit.setDlgPosition(tootltipDlg)
			$('.checkout-plcc-modal').css({top:($(window).height()/2) - ($('.checkout-plcc-modal').height()/2)});
			credit.modalHeight = $('.checkout-plcc-modal').height();
			credit.titleHeight = $('.checkout-plcc-modal .ui-dialog-titlebar').height();
			credit.modalContentHeight = $('.checkout-plcc-modal .dialog-content').height();
			credit.initTermsAndConditions('stepOneEvents', credit.modalHeight);
			imagesLoaded(tootltipDlg).on('done', function() {
				$(".ui-dialog-content:visible").each(function () {
					$(window).height() < $('.checkout-plcc-modal').height() && credit.xsWindowHeight(tootltipDlg, '.checkout-plcc-modal', prevHeight)
			        tootltipDlg.dialog("option","position", tootltipDlg.dialog("option","position"));
					credit.setDlgPosition(tootltipDlg);
					$('.checkout-plcc-modal').css({top:($(window).height()/2) - ($('.checkout-plcc-modal').height()/2)});
			    });
        	});
			if($('.ui-dialog').hasClass('checkout-plcc-modal') && $('.ui-dialog').length > 0) {
        		var $windowheight, $formButtonFixed, $checkoutStepOneTotalHeight, $closeDialog, $dialogOffsetTop;
        			$windowheight = $(window).height(),
        			$closeDialog = $('.ui-dialog').find('.ui-dialog-titlebar').outerHeight(),
        			$formButtonFixed = $('#dialog-container').find('.form-row.form-row-button').outerHeight(),
        			$dialogOffsetTop = $('.ui-dialog.checkout-plcc-modal').offset().top,
        			$checkoutStepOneTotalHeight = parseInt($windowheight) - parseInt($formButtonFixed) - parseInt($closeDialog);
        		if($('.checkout-tabs').hasClass('spc-express-checkout')) {
        			$('html, body').animate({scrollTop: $dialogOffsetTop}, 500);
        		}
        	}
        	var eventNames = [];
			eventNames.push('plc_offer_overlay');
			eventNames.push('plc_offer_initial');
			var obj = {
	    		event_name : eventNames
        	}
	        tealium.triggerEvent(obj);
	    }
	},
	stepOneContinueEvents: function() {
		presentation = 'PREAPPROVED_NO';
		$('body').off('click','.plcc-get-it-button').on('click','.plcc-get-it-button', credit.openApplication);
    	$("body").on('click','.plcc-nothanks-button', function(e){
    		e.preventDefault();
    		presentation = 'PREAPPROVED_NO';
    		madeOfferCall = true;
    		$(this).closest(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("click");
    	});
	},
	stepTwoEvents: function(isRebuttal) {
		validator.init();
		$('.plcc-accept-button').removeAttr('disabled');
		if(!util.isMobile()){
			$('.checkout-plcc-modal-step2 .cc-terms-iframe-content').not('.no-scroll').addClass('no-scroll');
		}
		presentation = 'PREAPPROVED_NO';
    	$("body").on('click','.plcc-nothanks-button', function(e){
    		e.preventDefault();
    		presentation = 'PREAPPROVED_NO';
    		$(this).closest(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("click");
    		$("#wrapper").removeAttr("style");
    	});
    	$('body').on('click',".plcc-accept-button",function(e){
    		//on opening pre approval/review/error step 2 modal dialog closes and made offer api gets called so make this to false
    		e.preventDefault();
    		madeOfferCall = false;
    		var $form = $(this).closest('form'),
    			action = $form.attr("action");
			var birthdateEl =  $form.find('input.birthdate');
    		var plccEventLocation = isRebuttal ? 'plc_rebuttal_overlay' : 'plc_initial_overlay';

			if (birthdateEl.length) {
				var splitBirthdate = birthdateEl.val().split('/');
				$form.find('input.birth-month').val(splitBirthdate[0]);
				$form.find('input.birth-date').val(splitBirthdate[1]);
				$form.find('input.birth-year').val(splitBirthdate[2]);
			}
    		
    		if (!$form.valid()) {
    			$('.invalid-form').removeClass('hide');
    			$('.plcc-modal-error').removeClass('hide');
    			$('input.phone').removeClass('hide');
                return false;
            } else {
            	$('.invalid-form').addClass('hide');
            	$(this).attr('disabled', 'disabled');
            }
    		if( $('input[name$="dwfrm_creditapplication_submit"]').length == 0){
    			$('<input type="hidden" name="' + $(this).attr('name') + '" value="true" />').appendTo($form);
    		}
    		
    		$.ajax({ 
    			url: action,
    			data: $form.serialize(),
    			method: 'POST', 
    			success: function(data) {
    				$("#wrapper").removeAttr("style");
    				if(data != '') {
    					$('.invalid-ssn-error').addClass('hide');
    					credit.applicationApprovalMarkup = data;
    					credit.openApplicationApproval();
						var stepTwoContinueDialog = $('.checkout-plcc-modal-step3');
						var plccEventName = 'plc_registration';
						
						if (!stepTwoContinueDialog.find('.approved-model').length) {
							plccEventName = stepTwoContinueDialog.find('.plcc-apply-error').length ? 'plc_error' : 'plc_review';
						}

						var obj = {
							event_name : plccEventName,
							event_location_plc: plccEventLocation
						}
						tealium.triggerEvent(obj);
						credit.stepTwoContinueEvent();
    				} else {
    					$('.invalid-ssn-error').removeClass('hide');
    					$('.plcc-accept-button').removeAttr('disabled');
    				}
    			}
    			
    		});
    	});
	},
	stepTwoContinueEvent: function() {
		$('body').off('click','.continue-checkout,.try-again').on('click','.continue-checkout,.try-again',function(e){
    		e.preventDefault(); 
    		$('html').hasClass('no-scroll') && $('html').removeClass('no-scroll');
    		$('.checkout-body').hasClass('no-scroll-checkout') && $('.checkout-body').removeClass('no-scroll-checkout');  
    		if ($(this).hasClass('review-checkout')) {
    			$(this).closest(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("click");
    			require('../spc').initPreScreen();
    		} else if ($('.spc-summary').length > 0) {
				$(this).closest(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("click");
            	var URL = Urls.updateBilling;
            	ajax.load({
                    url: URL,
                    method: 'POST',
                    callback: function (data) {
                        $('.checkout-tab.billing').html($(data).filter('.checkout-tab.billing').html());
                    }
                });
            } else {
    			$(this).closest(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("click");
    			if ($(this).hasClass('continue-checkout')) {
    				if($('.express-billing-refresh').length > 0) {
    					$(".express-billing-refresh[data-refreshurl]").trigger('click'); 
                    	scrollToActiveTab('expBill')
                    } else {
                    	$(".spc-billing .billing-refresh[data-refreshurl]").trigger('click');
                    	require('../spc').scrollToActiveTab();
                    }
    			}
    		}
    	});
	},
	openApplicationApproval: function() {
		var dialogContent = $(credit.applicationApprovalMarkup);
		var stepTwoContinueDialog = credit.createDialog('checkout-plcc-modal-step3');
		$('.checkout-plcc-modal-step3').css({height:credit.modalHeight});
		$('.checkout-plcc-modal-step3 .ui-dialog-titlebar').css({minHeight:credit.titleHeight});
	
		imagesLoaded(stepTwoContinueDialog).on('done', function() {
			$(".ui-dialog-content:visible").each(function () {
				credit.controlHeightStep3('.checkout-plcc-modal-step3', '.plcc-apply-model')
				stepTwoContinueDialog.dialog("option","position", stepTwoContinueDialog.dialog("option","position"));
			});
		});
		$(stepTwoContinueDialog).children().remove();
		$(stepTwoContinueDialog).append(dialogContent);
		stepTwoContinueDialog.dialog("open");
		credit.setDlgPosition(stepTwoContinueDialog);
		credit.initTermsAndConditions('openApplicationApproval', credit.modalHeight);
	},
	openApplication: function(e) {
		e.preventDefault();
		var isReview = false;
		var isRebuttal = $(e.currentTarget).hasClass('plcc-rebuttal-link');
		var plccEventLocation = isRebuttal ? 'plc_rebuttal_overlay' : 'plc_initial_overlay';
		var plccEventName = isRebuttal ? ['plc_offer_overlay', 'plc_offer_rebuttal'] : 'plc_offer_accepted';
		if ($('.pt_checkout .spc-shipping').length > 0) {
			isReview = true;
		}
		presentation = "PREAPPROVED_YES";
		var url = util.appendParamToURL(Urls.checkoutModalStep2, 'isReview', isReview);
	
		$.ajax({
			url: url,
			success: function(data) {
				var userBirthdate = "";
				var stepTwoDialog = credit.createDialog('checkout-plcc-modal-step2', plccEventLocation)
				$(stepTwoDialog).children().remove();
				$(stepTwoDialog).append(data);
				$(stepTwoDialog).find('.form-row.ssn input').attr('placeholder', '_ _ _ _');
				$(stepTwoDialog).find('.form-row.birthday .input-text').attr('placeholder', 'MM/DD/YYYY');
				$(stepTwoDialog).find('.form-row.birthday .input-text').attr('maxlength', '10');
				$(stepTwoDialog).find('.form-row.birthday .label-text').text('Birth Date:');
				$(stepTwoDialog).find('.form-row.birthday .input-text').val(userBirthdate);
				$(stepTwoDialog).find('.termsLink .label-text').after($('<span> </span><a class="plcc-terms-open" src="#" tabindex="0">terms & privacy policy</a><span>.</span>'));
				stepTwoDialog.dialog("open");
				credit.setDlgPosition(stepTwoDialog);
				$('.checkout-plcc-modal-step2').css({top:($(window).height()/2) - ($('.checkout-plcc-modal-step2').height()/2)});
				$(".show-profile .make-label-absolute fieldset").children().each(function (i,e) {
					$(this).on('focus', 'input, select', function(){
						$('.checkout-plcc-modal-step2 .dialog-content').animate({
							scrollTop:(100+$(this).height()*i*4)
						})
					})
				})

				util.updateselect();
				util.updateInputFields();
				credit.stepTwoEvents(isRebuttal);
				credit.setHeights('.checkout-plcc-modal-step2')
				
				imagesLoaded(stepTwoDialog).on('done', function() {
					$(".ui-dialog-content:visible").each(function () {
						$(window).height() < $('.checkout-plcc-modal-step2').height() && credit.xsWindowHeight(stepTwoDialog, '.checkout-plcc-modal-step2')
						credit.initTermsAndConditions('openApplication', credit.modalHeight);
						credit.setDlgPosition(stepTwoDialog);
						$('.checkout-plcc-modal-step2').css({top:($(window).height()/2) - ($('.checkout-plcc-modal-step2').height()/2)});

					});
				});

				$(stepTwoDialog).find('.form-row.birthday .input-text').on('keydown', function(e) {
					var pressedKey = e.key || '';
					var thisVal = e.currentTarget.value;
					var numChars = thisVal.length;
					var isValidSlash = pressedKey === '/' && (numChars === 1 || numChars === 2 || numChars === 4 || numChars === 5);
					var isRequiredKey = pressedKey === 'Backspace' || pressedKey === 'Tab' || pressedKey === 'ArrowLeft' || pressedKey === 'ArrowRight';

					if (!pressedKey.match(/\d/) && !isRequiredKey && !isValidSlash) {
						return false;
					}

					if(pressedKey !== '/') {
						if((numChars === 2 || numChars === 5) && pressedKey !== 'Backspace') {
							thisVal += '/';
							e.currentTarget.value = thisVal;
						}
					} else {
						var splitVal = thisVal.split('/');

						if (numChars < 2) {
							e.currentTarget.value = '0' + splitVal[0];
						} else if (numChars < 5 && splitVal[1]) {
							e.currentTarget.value = splitVal[0] + '/0' + splitVal[1];
						}
					}
				});

				var obj = {
					event_name : plccEventName,
				}
				if (!isRebuttal) {
					obj.event_location_plc = plccEventLocation;
				}
				tealium.triggerEvent(obj);

				$('.plcc-modal-accordion-content').accordion({
					collapsible: true,
					active: false
				});
		
				$("body").off("click",".plcc-header-row .plcc-details-open").on("click",".plcc-header-row .plcc-details-open", function(e) {
					e.preventDefault();
					var $accordionController = $(stepTwoDialog).find('.plcc-modal-accordion-content .plcc-accordion-control');
					var modalHeight = $(stepTwoDialog).height();
					$accordionController.trigger('click');
					if ($($accordionController).hasClass('ui-accordion-header-active')) {
						e.currentTarget.innerHTML = 'Close';
					} else {
						e.currentTarget.innerHTML = 'Details';
					}

					$(stepTwoDialog).find('.plcc-application-fieldset').css({height: modalHeight});
				});
			}
		});
	},
	initTermsAndConditions: function(prev, prevHeight) {
		$('body').off('click','.plcc-terms-open').on('click','.plcc-terms-open', function(e) {
			e.preventDefault();
			credit.openTermsAndConditions(prev, prevHeight);
		});
		$('body').off('keypress','.plcc-terms-open').on('keypress','.plcc-terms-open', function(e) {
			e.preventDefault();
			if (e.keyCode == 13) {
				credit.openTermsAndConditions(prev, prevHeight);
			}
		});
	},
	openTermsAndConditions: function(prev, prevHeight) {
		var isReview = false;
		var url = util.appendParamToURL(Urls.termsAndConditions, 'isReview', isReview);

		$.ajax({
			url: url,
			success: function(data) {
				var termsDialog = credit.createDialog('checkout-plcc-modal-terms');
				prevHeight && $('.checkout-plcc-modal-terms').css({maxHeight:prevHeight})
				var backButton = $('<button class="plcc-terms-back" tabindex="0"> Back</button>');
				$(termsDialog).prev().append(backButton);
				$(termsDialog).children().remove();
				$('.checkout-plcc-modal-terms').css({height:credit.modalHeight});
				$(termsDialog).append(data);
				termsDialog.dialog("open");
				credit.setDlgPosition(termsDialog);
				credit.setHeights('.checkout-plcc-modal-terms')

				$('.checkout-plcc-modal-terms').css({height:credit.modalHeight});
				$('.checkout-plcc-modal-terms .ui-dialog-titlebar').css({height:credit.titleHeight});
				$('.checkout-plcc-modal-terms .dialog-content').css({height:credit.modalContentHeight, maxHeight:credit.modalContentHeight});
				
				credit.setDlgPosition(termsDialog);

				imagesLoaded(termsDialog).on('done', function() {
					$('.checkout-plcc-modal-terms').find('.plcc-terms-back').focus();
					$(".ui-dialog-content:visible").each(function () {
						$(window).height() < $('.checkout-plcc-modal-terms').height() && credit.xsWindowHeight(termsDialog, '.checkout-plcc-modal-terms', prevHeight)
						credit.setDlgPosition(termsDialog);

					});
				});

				$('.plcc-terms-back').on('click', function(event) {
					event.preventDefault();
					if (prev) {
						credit[prev](event, prevHeight);
					} else {
						$(termsDialog).dialog('close');
					}
					$('.plcc-terms-back').remove();
					scrollToActiveTab();
				});
			}
		});
	}
};
module.exports = credit;